package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class GardenUserRequest(
    val email: String,
    val password: String
)

@Serializable
data class GardenUser(
    val email: String,
    val token: String = "",
    val refreshToken: String = ""
)

@Serializable
data class RefreshTokenRequest(
    val refreshToken: String
)